import { DatabaseOutlined } from '@ant-design/icons';
import { Alert, Col, Divider, Row } from 'antd';
import PageWrapper from 'common/page-wrapper';
import { useHistory } from 'react-router-dom';
import { useGetUserContextQuery } from 'services/user-context/user-context-api';
import styled from 'styled-components';
import { canAccessCaseTypes, canAccessPCodes } from 'utils/role-conditions';

const Wrapper = styled.div`
  background-color: white;
`;

const PanelWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 35px;
  border-radius: 5px;
  flex-wrap: wrap;
  color: white;

  position: relative;
  span {
    text-align: center;
    margin-bottom: 6px;
    font-size: 1.5rem;
  }
  svg {
    margin-bottom: 12px;
    font-size: 3rem;
  }
  &:hover {
    cursor: pointer;
    span {
      text-decoration: underline;
    }
  }
`;

const Header = styled(Divider)`
  font-family: 'RobotoCondensed';
  span {
    font-size: 1.5rem;
  }
`;

const AlertTitle = styled.p`
  font-family: 'RobotoCondensedBold';
  padding: 0;
  margin: 0;
`;

const Title = styled.h1`
  color: ${(props) => props.theme.colors.brandBlue};
  font-family: 'RobotoCondensedBold';
  font-size: 2rem;
`;

const panelColors = {
  caseTypes: '#E67E22',
  pcodes: '#27ae60',
  future2: '#004A99',
  future3: '#004A99',
};

const NavPanel = () => {
  const navigation = useHistory();
  const { data: userContext } = useGetUserContextQuery();
  return (
    <PageWrapper backgroundColor="white">
      <>
        <Title>Risk Assessment Process Configurator</Title>
        <Wrapper>
          <Header titlePlacement="start" styles={{ content: { margin: 0 } }}>
            Data Management
          </Header>
          {!userContext?.hasNoDataTypeAccess ? (
            <Row gutter={24}>
              {canAccessCaseTypes(userContext?.roles) && (
                <Col
                  onClick={() => {
                    navigation.replace('/case-types');
                  }}
                  span={6}
                >
                  <PanelWrapper
                    style={{ backgroundColor: panelColors.caseTypes }}
                  >
                    <DatabaseOutlined />
                    <span>Casetypes</span>
                  </PanelWrapper>
                </Col>
              )}
              {canAccessPCodes(userContext?.roles) && (
                <Col
                  onClick={() => {
                    navigation.replace('/pcodes');
                  }}
                  span={6}
                >
                  <PanelWrapper style={{ backgroundColor: panelColors.pcodes }}>
                    <DatabaseOutlined />
                    <span>Pcodes</span>
                  </PanelWrapper>
                </Col>
              )}
            </Row>
          ) : (
            <Alert
              message={<AlertTitle>Unauthorized Access</AlertTitle>}
              description="You do not have the minimum required access level to view any Data Types. Please contact your local admin."
              type="warning"
              showIcon
            />
          )}
        </Wrapper>
      </>
    </PageWrapper>
  );
};

export default NavPanel;
